/**
 * Download Center - Data Definitions
 */

const searchFormValue = {
    status: null,
    filename: null,
    fromDate: null,
    toDate: null,
    includeOthers: false,
};

const statusOptions = [
    { text: '전체', value: null },
    { text: '대기', value: 'ready' },
    { text: '처리중', value: 'processing' },
    { text: '완료', value: 'completed' },
    { text: '실패', value: 'failed' },
];



const columns = [
    {
        key: 'selected',
        label: '',
        thStyle: {
            width: '40px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'id',
        label: 'ID',
        thStyle: {
            width: '70px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'filename',
        label: '파일명',
        thStyle: {
            width: '250px'
        },
        thClass: ['mb-0', 'th-left'],
        tdClass: ['td-left', 'text-truncate'],
    },
    {
        key: 'fileSize',
        label: '파일 크기',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-right'],
        tdClass: ['td-right'],
    },
    {
        key: 'status',
        label: '상태',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'requestUserId',
        label: '요청자',
        thStyle: {
            width: '120px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'createdAt',
        label: '생성일시',
        thStyle: {
            width: '150px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
    {
        key: 'action',
        label: '다운로드',
        thStyle: {
            width: '100px'
        },
        thClass: ['mb-0', 'th-center'],
        tdClass: ['td-center'],
    },
];

// Size warning threshold: 500MB
const SIZE_WARNING_THRESHOLD = 500 * 1024 * 1024;

export { searchFormValue, columns, statusOptions, SIZE_WARNING_THRESHOLD };

